import { render } from "./HamburgerButton.vue?vue&type=template&id=05236705&scoped=true"
import script from "./HamburgerButton.vue?vue&type=script&lang=ts"
export * from "./HamburgerButton.vue?vue&type=script&lang=ts"

import "./HamburgerButton.vue?vue&type=style&index=0&id=05236705&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-05236705"

export default script